// Centralizza gli indirizzi di contatto e link usati nell'app

// Informazioni aziendali
export const COMPANY_NAME = "FER-AL di Forconi Luana e Di Profio Massimiliano SNC";
export const VAT_NUMBER = "03667190486"; // P. IVA dal sito ufficiale
export const REA_NUMBER = ""; // Non indicato sul sito pubblicamente

// Contatti ufficiali (pagina Contatti)
export const CONTACT_EMAIL = "fer-al@libero.it";
export const MAILTO = `mailto:${CONTACT_EMAIL}`;

export const FACEBOOK_URL = "https://www.facebook.com/FERAL1967/?locale=it_IT"; // Link social non rilevato nella pagina

// PEC (non disponibile sulla pagina pubblica)
export const PEC_EMAIL = "fer-al@pec.it";

// Telefono (Tel./Fax)
export const PHONE_DISPLAY = "+39 055 7398703";
export const PHONE_TEL = "tel:+390557398703";

// Indirizzi (Esposizione e Sede/Officina)
export const SHOWROOM_ADDRESS = "Via Bronzino 24/B rosso, 50142 Firenze";
export const WORKSHOP_ADDRESS = "Via Bronzino 24/C rosso, 50142 Firenze";
// Manteniamo un indirizzo principale per compatibilità dove serve una sola stringa
export const ADDRESS_LINE = SHOWROOM_ADDRESS;
export const ADDRESS_CITY = "Firenze";

// Link alla mappa (embed per iframe e link breve per app/maps)
export const MAP_EMBED_URL =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2880.4837305672874!2d11.254167476541724!3d43.77166427109776!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132a56a4e2f3e7d7%3A0x7e8e8e8e8e8e8e8e!2sVia%20del%20Bronzino%2C%2024%2C%2050142%20Firenze%20FI!5e0!3m2!1sit!2sit!4v1234567890123!5m2!1sit!2sit";
export const MAP_SHORT_LINK = "https://maps.app.goo.gl/Zk3NSb53EhjHxY179"; // Placeholder: sostituire con link ufficiale se fornito

const contacts = {
  COMPANY_NAME,
  VAT_NUMBER,
  REA_NUMBER,
  CONTACT_EMAIL,
  MAILTO,
  FACEBOOK_URL,
  PEC_EMAIL,
  PHONE_DISPLAY,
  PHONE_TEL,
  ADDRESS_LINE,
  ADDRESS_CITY,
  SHOWROOM_ADDRESS,
  WORKSHOP_ADDRESS,
  MAP_EMBED_URL,
  MAP_SHORT_LINK,
};

export default contacts;
